import { render, staticRenderFns } from "./NavFull.vue?vue&type=template&id=5ec1f2de&scoped=true"
import script from "./NavFull.vue?vue&type=script&lang=js"
export * from "./NavFull.vue?vue&type=script&lang=js"
import style0 from "./NavFull.vue?vue&type=style&index=0&id=5ec1f2de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec1f2de",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MiscElementsLoader: require('/home/travis/build/Polumathes/LTNG-1800-Frontend/components/MiscElements/Loader.vue').default,NavigationFullDropdown: require('/home/travis/build/Polumathes/LTNG-1800-Frontend/components/Navigation/NavigationFullDropdown.vue').default})
